import { useWillMount } from '@beef/react';
import React, { useEffect } from 'react';
import { useStore } from 'react-redux';
import { logger } from "./logger";
import { Metric as BaseMetric } from "./Metric";
import MetricObserver from "./observers/MetricObserver";
import MetricEventListener from "./observers/MetricEventListener";
import { convertEventsConfig, fireEvents } from "./utils/fireEvents";
export var listenMetric = function listenMetric(helpers) {
  var metricObserver = new MetricObserver(helpers);
  var metricListener = new MetricEventListener(helpers);
  return {
    unlisten: function unlisten() {
      metricObserver.disconnect();
      metricListener.disconnect();
    }
  };
};
var defineLevel = function defineLevel(level) {
  if (process.env.NODE_ENV === 'production') return 'error';
  if (!level) return 'warn';
  return level;
};

/* Функция первоначальной инициации метрики. Возвращает необходимые для работы компонент, утилиты и хуки */
export var createMetric = function createMetric(helpers, logLevel) {
  logger.setLevel(defineLevel(logLevel));

  /* Опциональный хук для однократного использования в корневых компонентах.
   * Прокидывает store в метрику
   */
  var useReduxStoreForMetric = function useReduxStoreForMetric() {
    var store = useStore();
    useWillMount(function () {
      return (
        // eslint-disable-next-line @typescript-eslint/unbound-method
        Object.values(helpers).forEach(function (helper) {
          return helper.setDataGetter(store.getState);
        })
      );
    });
  };

  /* Хук для однократного использования в корневых компонентах.
   * Добавляет необходимые для работы слушатели событий.
   */
  var useMetricListeners = function useMetricListeners() {
    useEffect(function () {
      var _listenMetric = listenMetric(helpers),
        unlisten = _listenMetric.unlisten;
      return unlisten;
    }, []);
  };

  /* HOC для оборачивания всего приложения,
   * Добавляет необходимые для работы слушатели событий.
   */
  var withMetricListeners = function withMetricListeners(Component) {
    return function (props) {
      useMetricListeners();
      return /*#__PURE__*/React.createElement(Component, props);
    };
  };

  /* HOC для оборачивания всего приложения,
   * Добавляет необходимые для работы слушатели событий.
   * Прокидывает store в метрику
   */
  var withMetricContainer = function withMetricContainer(Component) {
    return function (props) {
      useReduxStoreForMetric();
      useMetricListeners();
      return /*#__PURE__*/React.createElement(Component, props);
    };
  };

  /* Компонент для оборачивания частей приложения, подлежащих покрытию метриками */
  var Metric = BaseMetric;

  /* HOC для оборачивания частей приложения, подлежащих покрытию метриками */
  var withMetric = function withMetric(metricProps) {
    return function (Component) {
      return function (props) {
        return /*#__PURE__*/React.createElement(Metric, metricProps, /*#__PURE__*/React.createElement(Component, props));
      };
    };
  };

  /* Декоратор для функций-хэндлеров.
   * Добавляет отправку выбранных метрик при выполнении основной функции.
   * Использовать только при невозможности использовании MetricContainer. */
  var decorateHandler = function decorateHandler(handler, eventsConfig) {
    return function () {
      fireEvents(convertEventsConfig(eventsConfig), helpers);
      return handler.apply(void 0, arguments);
    };
  };
  return {
    useReduxStoreForMetric: useReduxStoreForMetric,
    useMetricListeners: useMetricListeners,
    withMetricListeners: withMetricListeners,
    withMetricContainer: withMetricContainer,
    Metric: Metric,
    withMetric: withMetric,
    decorateHandler: decorateHandler
  };
};